import { Component, Input } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { DecidoEvaluation, DecidoEvaluationService } from 'src/app/core/decido-evaluation.service';
import { Order, OrderStatus, VbanStatus } from 'src/app/core/orders.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { UtilsService } from 'src/app/core/utils.service';
import { OrderDetailsNoteDialogComponent } from '../order-details-note-dialog/order-details-note-dialog.component';
import { OrderDetailsLookedAtDialogComponent } from '../order-details-looked-at-dialog/order-details-looked-at-dialog.component';

@Component({
  selector: 'app-order-details-general-info',
  templateUrl: './order-details-general-info.component.html',
  styleUrls: ['./order-details-general-info.component.scss'],
})
export class OrderDetailsGeneralInfoComponent {
  @Input() order?: Order;
  decido_evaluation_bd1?: DecidoEvaluation;
  decido_evaluation_bd2?: DecidoEvaluation;
  decido_evaluation_bd5?: DecidoEvaluation;

  constructor(
    private utils_service: UtilsService,
    private decido_evaluation_service: DecidoEvaluationService,
    private dialog_service: DialogService,
    private error_service: ErrorService,
  ) {}

  onEditNoteClick(): void {
    this.dialog_service
      .openDialog(OrderDetailsNoteDialogComponent, {
        order_id: this.order?.order_id,
        store_id: this.order?.store_id,
        note: this.order?.note,
      })
      ?.afterClosed()
      .subscribe(result => {
        if (result?.success && this.order) {
          this.order.note = result.note;
        }
        if (result?.error) {
          const processed_error: SplittypayError = result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onEditLookedAtClick(): void {
    this.dialog_service
      .openDialog(OrderDetailsLookedAtDialogComponent, {
        order_id: this.order?.order_id,
        store_id: this.order?.store_id,
        is_looked_at: this.order?.is_looked_at ?? false,
      })
      ?.afterClosed()
      .subscribe(result => {
        if (result?.success && this.order) {
          this.order.is_looked_at = result.is_looked_at;
        }
        if (result?.error) {
          const processed_error: SplittypayError = result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  ngOnInit(): void {
    const buyer_id = this.order?.buyer_id;
    if (!buyer_id) return;

    if (this.order?.bd1_evaluation_id)
      this.readEvaluation(this.order.bd1_evaluation_id, buyer_id, 'decido_evaluation_bd1');

    if (this.order?.bd2_evaluation_id)
      this.readEvaluation(this.order.bd2_evaluation_id, buyer_id, 'decido_evaluation_bd2');

    if (this.order?.bd5_evaluation_id)
      this.readEvaluation(this.order.bd5_evaluation_id, buyer_id, 'decido_evaluation_bd5');
  }

  getOrderStatusLabel(status?: OrderStatus): string {
    return this.utils_service.getOrderStatusLabel(status);
  }

  getOrderStatusClass(status?: OrderStatus): string {
    return this.utils_service.getOrderStatusClass(status);
  }

  getCurrencyLabel(order: Order): string {
    return this.utils_service.getCurrencyLabelFromOrder(order);
  }

  getFormattedAmount(order?: Order): string {
    if (order?.amount?.total != null) {
      const order_amount = order.amount.total / 100;

      const formatted_amount = order_amount.toLocaleString('it-IT', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      const order_currency = this.getCurrencyLabel(order);

      return `${formatted_amount} ${order_currency}`;
    } else {
      return '-';
    }
  }

  getVbanStatusLabel(status?: VbanStatus): string {
    return this.utils_service.getVbanStatusLabel(status);
  }

  readEvaluation(
    id: string,
    buyerId: string,
    target: 'decido_evaluation_bd1' | 'decido_evaluation_bd2' | 'decido_evaluation_bd5',
  ): void {
    this.decido_evaluation_service.read(id, buyerId).subscribe({
      next: response => (this[target] = response.data),
      error: () => (this[target] = undefined),
    });
  }

  getEvaluationClass(result?: string): string {
    if (result && result.toUpperCase() == 'DEL-POS') {
      return 'sp-color__green';
    }
    return 'sp-color__red';
  }
}
